<template>
  <div style="padding: 10px;">
    <div style="white-space: pre-wrap;text-align: center;font-size: 16pt;">
      轻客账户迁移
    </div>
    <div style="text-align: left;">
      <van-field v-model="phone" type="tel" maxlength="11" label="手机号" placeholder="请输入手机号"/>
      <van-field
        v-model="verifyCode"
        type="digit"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
        maxlength="6"
      >
        <template #button>
          <van-button size="small" type="primary" color="#46C9BA" v-on:click="sendVerifyCode">发送验证码</van-button>
        </template>
      </van-field>

      <div style="padding-top: 35px;"></div>
      <van-button type="primary" color="#46C9BA" block v-on:click="verifyAccount">验证轻客账户</van-button>
      <div style="padding-top: 20px;"></div>
      <div style="white-space: pre-wrap;text-align: left;font-size: 10pt;color:red;">
        注意事项：
        1、本功能支持从【轻客洗衣】应用迁移轻币余额至新账户。
        2、需要输入原应用对应的手机号码进行验证。
        3、迁移完成后，原应用中的相关权益将清空，权益转移至新的应用当中。
        4、原手机号码无法进行验证则不能进行迁移，如果疑问请登录原应用进行信息核对。
      </div>

    </div>
    <div style="white-space: pre-wrap;text-align: center;">
      <van-list @load="onLoad"></van-list>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        phone: '',
        verifyCode: ''
      }
    },
    methods: {
      onLoad: function () {
        console.log('onload...')
      },
      sendVerifyCode () {
        if (this.phone == null || this.phone.length != 11) {
          this.$toast.fail('手机号格式不正确!')
          return
        }

        let data = new FormData()
        data.append('phone', this.phone)

        this.$axios.post('/api/useraccountmove/send-verifycode', data).then(res => {
          if (res.data.success) {
            this.$toast.success('验证码发送成功!')
          } else {
            this.$toast.fail('操作失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('操作失败!')
        })

      },

      verifyAccount () {
        if (this.phone == null || this.phone.length != 11) {
          this.$toast.fail('手机号格式不正确!')
          return
        }

        if (this.verifyCode == null || this.verifyCode.length != 6) {
          this.$toast.fail('请输入正确的短信验证码!')
          return
        }

        let data = new FormData()
        data.append('phone', this.phone)
        data.append('verifyCode', this.verifyCode)

        let customerId = this.$route.query.customerId
        this.$axios.post('/api/useraccountmove/useraccount-verify', data).then(res => {
          if (res.data.success) {
            let bizCode = res.data.userObject
            this.$router.push({
              path: '/user/accountmoveconfirm',
              query: {
                'customerId': customerId,
                'phone': this.phone,
                'bizCode': bizCode
              }
            })
          } else {
            this.$toast.fail('验证失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('操作失败!')
        })

      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/user/UserAccountMove.vue